import React, { Component } from "react";
// core components
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import _ from "lodash";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import DateRangeOutline from "@material-ui/icons/DateRangeOutlined";
const styles = (theme) => ({
  cardText: {
    color: "grey",
  },
  cardTitle: {
    fontSize: "20px",
    marginTop: "180px",
  },
  cardUpdateInfo: {
    fontSize: "13px",
  },
  chart: {
    position: "absolute",
    marginTop: "-30px",
    zIndex: 10,
    width: "100%",
  },
});

class StatisticCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      datatable: [],
      selectedCategory: "",
      selectedCategoryPeriode: "30",
      catspeed: [],
    };
  }

  UNSAFE_componentWillMount() {}

  render() {
    const { classes } = this.props;
    const option1 = {
      chart: {
        type: this.props.chartType,
        backgroundColor: this.props.chartBgColor,
        height: "200px",
        borderRadius: 5,
        // style: { maxWidth: "500px" },
        // width: 500,
      },
      title: {
        text: "",
      },
      credits: {
        enabled: false,
      },
      xAxis: {
        categories: ["Jun 2021", "Jul 2021", "Aug 2021", "Sept 2021", "Oct 2021", "Nov 2021"],
        labels: {
          style: {
            color: this.props.chartColor,
          },
        },
      },
      yAxis: {
        title: {
          text: "",
        },
        labels: {
          style: {
            color: this.props.chartColor,
          },
        },
      },
      legend: {
        enabled: false,
      },
      plotOption: {
        series: {
          label: {
            connectorAllowed: false,
          },
        },
      },
      series: [
        {
          name: "Data",
          color: this.props.chartColor,
          data: [884, 993, 920,  918, 1367, 87],
        },
      ],
    };
    const option2 = {
      chart: {
        type: this.props.chartType,
        backgroundColor: this.props.chartBgColor,
        height: "200px",
        borderRadius: 5,
        // style: { maxWidth: "500px" },
        // width: 500,
      },
      title: {
        text: "",
      },
      credits: {
        enabled: false,
      },
      xAxis: {
        categories: [
          "BL (Bulk Lighter)",
          "GP (General Purpose) I",
          "MR (Medium Range) I",
          "OB (Oil Barge)",
          "Satgas",
          "Small Tangker I",
          "Small Tangker II",
          "SPOB"
        ],
        labels: {
          style: {
            color: this.props.chartColor,
          },
        },
      },
      yAxis: {
        title: {
          text: "",
        },
        labels: {
          style: {
            color: this.props.chartColor,
          },
        },
      },
      legend: {
        enabled: false,
      },
      plotOption: {
        series: {
          label: {
            connectorAllowed: false,
          },
        },
      },
      series: [
        {
          name: "Data",
          color: this.props.chartColor,
          data: [1, 1, 1, 1, 4, 1, 1,],
        },
      ],
    };
    const option3 = {
      chart: {
        type: this.props.chartType,
        backgroundColor: this.props.chartBgColor,
        height: "200px",
        borderRadius: 5,
        // style: { maxWidth: "500px" },
        // width: 500,
      },
      title: {
        text: "",
      },
      credits: {
        enabled: false,
      },
      xAxis: {
        categories: ["Jun", "Jul ", "Aug", "Sept", "Oct", "Nov"],
        labels: {
          style: {
            color: this.props.chartColor,
          },
        },
      },
      yAxis: {
        title: {
          text: "",
        },
        labels: {
          style: {
            color: this.props.chartColor,
          },
        },
      },
      legend: {
        enabled: false,
      },
      plotOption: {
        series: {
          label: {
            connectorAllowed: false,
          },
        },
      },
      series: [
        {
          name: "Data",
          color: this.props.chartColor,
          data: [5, 7, 8, 3, 0, 0],
        },
      ],
    };
    return (
      <Grid item xs={12} lg={4}>
        <Card style={{overflow: "visible"}}>
          <CardContent>
            <div style={{ width: "100%",position: "relative" }}>
              <div className={classes.chart}>
                <HighchartsReact
                  highcharts={Highcharts}
                  options={
                    this.props.option === 1
                      ? option1
                      : this.props.option === 2
                        ? option2
                        : option3
                  }
                />
              </div>
            </div>
            <p className={`${classes.cardTitle} ${classes.cardText}`}>
              {this.props.title}
            </p>
            <p className={classes.cardUpdateInfo}>
              <span>
                <DateRangeOutline style={{ fontSize: "13px" }} />
              </span>{" "}
              last update 08/11/2021
            </p>
          </CardContent>
        </Card>
      </Grid>
    );
  }
}

export default withStyles(styles)(StatisticCard);
